export default "__VITE_ASSET__YYsDOVJu__"